<template>
  <div
    v-if="page"
    :class="$style.root"
  >
    <LayoutIntroductionHeaderComponent :page="page" />
    <CoreBlocksComponent
      v-if="page?.blocks"
      :blocks="page?.blocks"
      :class="$style.blocks"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

const page = baseStrapiGetAttributes(props.data)

</script>

<style module>
.root {
  --layout--introduction-header--margin-bottom: calc(var(--unit--vertical) * 2);
}

.blocks {
}
</style>
